import { css } from '@emotion/react';
import tw from 'twin.macro';

import { colorConstants } from 'config/colorConstants';

export const AXIS_CONFIGURATION_MODAL_CLASS = 'pack-architecture-axis-configuration-modal';
export const BINNING_MODAL = 'custom-binning-modal';

export const axisConfigurationModalGlobalStyles = css`
    .${AXIS_CONFIGURATION_MODAL_CLASS} .ant-modal-content {
        border-radius: 8px;
        overflow: hidden;
        height: min(466px, calc(100vh - 80px));
        display: flex;
        flex-direction: column;
        ${tw`bg-axisModalBg`}
    }

    .${BINNING_MODAL} .ant-modal-content {
        height: min(490px, calc(100vh - 80px)) !important;
    }

    .${AXIS_CONFIGURATION_MODAL_CLASS} .ant-modal-header {
        padding: 16px 24px;
        margin-bottom: 0;
        ${tw`border-b border-backgroundLightGrey bg-white`}
        border-radius: 8px 8px 0 0;
    }

    .${AXIS_CONFIGURATION_MODAL_CLASS} .ant-modal-title {
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;
        ${tw`text-blackAlt`}
    }

    .${AXIS_CONFIGURATION_MODAL_CLASS} .ant-modal-body {
        padding: 0;
        flex: 1;
        min-height: 0;
        ${tw`bg-axisModalBg`}
    }

    .${AXIS_CONFIGURATION_MODAL_CLASS} .ant-modal-close {
        top: 16px;
        right: 24px;
        width: 24px;
        height: 24px;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .${AXIS_CONFIGURATION_MODAL_CLASS} .ant-modal-close-x {
        width: 24px;
        height: 24px;
        line-height: 1;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .${AXIS_CONFIGURATION_MODAL_CLASS} .ant-modal-close:hover {
        background: transparent;
    }

    .${AXIS_CONFIGURATION_MODAL_CLASS} .ant-modal-footer {
        padding: 16px 24px;
        margin-top: 0;
        text-align: unset;
        ${tw`border-t border-backgroundLightGrey bg-white`}
        border-radius: 0 0 8px 8px;
    }

    .${AXIS_CONFIGURATION_MODAL_CLASS} .axis-show-top-slider .ant-slider-track {
        ${tw`bg-purpleFont`}
    }

    .${AXIS_CONFIGURATION_MODAL_CLASS} .axis-show-top-slider .ant-slider-handle {
        ${tw`border-purpleFont`}
    }

    .${AXIS_CONFIGURATION_MODAL_CLASS} .axis-show-top-slider:hover .ant-slider-track {
        ${tw`bg-purpleFont`}
    }

    .${AXIS_CONFIGURATION_MODAL_CLASS} .axis-show-top-slider:hover .ant-slider-handle:not(.ant-tooltip-open) {
        ${tw`border-purpleFont`}
    }

    .${AXIS_CONFIGURATION_MODAL_CLASS} .axis-show-top-input-error.ant-input-number,
    .${AXIS_CONFIGURATION_MODAL_CLASS} .axis-show-top-input-error.ant-input-number-focused,
    .${AXIS_CONFIGURATION_MODAL_CLASS} .axis-show-top-input-error:focus-within {
        ${tw`!border-axisInputErrorBorder`}
        box-shadow: none !important;
    }

    .${AXIS_CONFIGURATION_MODAL_CLASS} .axis-group-rest-checkbox.ant-checkbox-wrapper-disabled {
        ${tw`text-fontGreyAlt1`}
    }

    .${AXIS_CONFIGURATION_MODAL_CLASS} .axis-group-rest-checkbox.ant-checkbox-wrapper-disabled span {
        ${tw`text-fontGreyAlt1`}
    }

    .${AXIS_CONFIGURATION_MODAL_CLASS} .axis-show-vendor-first-checkbox {
        display: inline-flex;
        align-items: center;
        height: 100%;
        line-height: 22px;
    }

    .${AXIS_CONFIGURATION_MODAL_CLASS} .axis-show-vendor-first-checkbox .ant-checkbox {
        top: 0;
    }

    .${AXIS_CONFIGURATION_MODAL_CLASS} .axis-show-vendor-first-checkbox .ant-checkbox + span {
        line-height: 22px;
        ${tw`!text-blackTitle`}
    }

    .${AXIS_CONFIGURATION_MODAL_CLASS} .axis-show-vendor-first-checkbox:hover .ant-checkbox .ant-checkbox-inner,
    .${AXIS_CONFIGURATION_MODAL_CLASS} .axis-show-vendor-first-checkbox .ant-checkbox:hover .ant-checkbox-inner {
        border-color: ${colorConstants.borderGrey} !important;
    }

    .${AXIS_CONFIGURATION_MODAL_CLASS} .axis-apply-btn.ant-btn-primary {
        background-color: ${colorConstants.violet} !important;
        border-color: ${colorConstants.violet} !important;
        color: ${colorConstants.white} !important;
    }

    .${AXIS_CONFIGURATION_MODAL_CLASS} .axis-apply-btn.ant-btn-primary:hover,
    .${AXIS_CONFIGURATION_MODAL_CLASS} .axis-apply-btn.ant-btn-primary:focus {
        background-color: ${colorConstants.purpleFontSelected} !important;
        border-color: ${colorConstants.purpleFontSelected} !important;
        color: ${colorConstants.white} !important;
    }

    .${AXIS_CONFIGURATION_MODAL_CLASS} .axis-apply-btn.ant-btn-primary:active {
        background-color: ${colorConstants.purpleFontPressed} !important;
        border-color: ${colorConstants.purpleFontPressed} !important;
        color: ${colorConstants.white} !important;
    }

    .${AXIS_CONFIGURATION_MODAL_CLASS} .axis-apply-btn.ant-btn-primary[disabled],
    .${AXIS_CONFIGURATION_MODAL_CLASS} .axis-apply-btn.ant-btn-primary[disabled]:hover,
    .${AXIS_CONFIGURATION_MODAL_CLASS} .axis-apply-btn.ant-btn-primary[disabled]:focus,
    .${AXIS_CONFIGURATION_MODAL_CLASS} .axis-apply-btn.ant-btn-primary[disabled]:active {
        background-color: ${colorConstants.violet} !important;
        border-color: ${colorConstants.violet} !important;
        color: ${colorConstants.white} !important;
        opacity: 0.4;
        cursor: not-allowed;
    }

    .${AXIS_CONFIGURATION_MODAL_CLASS} .kpi-breakpoint-chip .ant-input-number,
    .${AXIS_CONFIGURATION_MODAL_CLASS} .kpi-breakpoint-chip .ant-input-number.ant-input-number-focused,
    .${AXIS_CONFIGURATION_MODAL_CLASS} .kpi-breakpoint-chip .ant-input-number:focus-within {
        border-color: transparent !important;
        box-shadow: none !important;
        background: transparent;
    }

    .${AXIS_CONFIGURATION_MODAL_CLASS} .kpi-breakpoint-chip .ant-input-number-input-wrap,
    .${AXIS_CONFIGURATION_MODAL_CLASS} .kpi-breakpoint-chip .ant-input-number-focused .ant-input-number-input-wrap {
        border-color: transparent !important;
        box-shadow: none !important;
    }

    .${AXIS_CONFIGURATION_MODAL_CLASS} .kpi-breakpoint-chip .ant-input-number-input,
    .${AXIS_CONFIGURATION_MODAL_CLASS} .kpi-breakpoint-chip .ant-input-number-input:focus {
        border-color: transparent !important;
        box-shadow: none !important;
        outline: none;
    }
`;
